module.exports = __webpack_public_path__ + "img/Kubbi.40e0a812.jpg";